export default "__VITE_ASSET__4eb98ad9__"